<template>
  <div class="create">
    <div class="header-timeline">
      <a-steps :current="2">
        <a-step title="填写职位信息" />
        <a-step title="选择职位服务" />
        <a-step title="填写推广信息" />
        <a-step title="发布职位" />
      </a-steps>
    </div>
    <div class="content">
      <!-- accept=".jpg,.bmp,.png,.jpeg" -->
      <el-form
        ref="ruleForm"
        :rules="rules"
        :model="ruleForm"
        label-width="120px"
      >
        <el-form-item label="职位相关视频" prop="fileList_video">
          <el-upload
            class="upload-demo"
            :action="uploadUrl"
            :on-preview="handlePreview"
            :on-success="handleVideo"
            :on-remove="videoRemove"
            :limit="1"
            :file-list="fileList_video"
            accept=".mp4,.mp3"
          >
            <el-button size="small" type="primary"> + 上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item
          label="职位视频封面"
          prop="fileList_videocover"
          v-if="fileList_video.length > 0"
        >
          <el-upload
            class="upload-demo"
            :action="uploadUrl"
            :on-preview="handlePreview"
            :on-success="handleVideoCover"
            :on-remove="videoCoverRemove"
            :limit="1"
            :file-list="fileList_videocover"
            accept=".jpg,.jpeg,.png"
          >
            <el-button size="small" type="primary"> + 上传</el-button>
          </el-upload>
        </el-form-item>

        <el-form-item label="职位相关图片" prop="fileList_img">
          <el-upload
            class="upload-demo"
            :action="uploadUrl"
            :on-preview="handlePreview"
            :on-success="handleImages"
            :on-remove="imagesRemove"
            :limit="20"
            :file-list="fileList_img"
            accept=".jpg,.jpeg,.png"
          >
            <el-button size="small" type="primary"> + 上传</el-button>
            <div slot="tip" class="el-upload__tip">
              支持格式jpg/png文件，最多上传20张图片
            </div>
          </el-upload>
        </el-form-item>

        <el-form-item label="职位相关资讯" prop="dataList_article">
          <el-button size="small" type="primary" @click="handleAddArticle">
            + 新建</el-button
          >
          <Table
            style="width: 1000px; margin-top: 20px"
            ref="multipleTable"
            :tableHeader="tableHeaderArticle"
            :tableData="dataList_article"
            :config="PageConfig"
          >
            <template v-slot:handles="params">
              <el-button
                type="primary"
                size="mini"
                @click="articleEdit(params.row)"
                >编辑</el-button
              >
              <el-button
                type="danger"
                size="mini"
                @click="articleDelete(params.row)"
                >删除</el-button
              >
            </template>
          </Table>
        </el-form-item>

        <el-form-item label="职位推广海报" prop="fileList_poster">
          <el-upload
            :action="uploadUrl"
            list-type="picture-card"
            :limit="20"
            :on-preview="handlePictureCardPreview"
            :on-success="handlePoster"
            :on-remove="handleRemove"
            :file-list="fileList_poster"
            accept=".jpg,.jpeg,.png"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="" />
          </el-dialog>

          <!-- <el-button size="small" type="primary"> + 上传</el-button> -->
          <div slot="tip" class="el-upload__tip">
            支持格式jpg/png文件，最多上传20张图片
          </div>
        </el-form-item>

        <el-form-item label="职位分享文案" prop="dataList_text">
          <el-button size="small" type="primary" @click="handleAddText">
            + 添加</el-button
          >
          <Table
            style="width: 500px; margin-top: 20px"
            ref="multipleTable"
            :tableHeader="tableHeaderText"
            :tableData="dataList_text"
            :config="PageConfig"
          >
            <template v-slot:handles="params">
              <el-button
                type="primary"
                size="mini"
                @click="handleEdit(params.row)"
                >编辑</el-button
              >
              <el-button
                type="danger"
                size="mini"
                @click="handleDelete(params.row)"
                >删除</el-button
              >
            </template>
          </Table>
        </el-form-item>

        <el-form-item label="关联直播专场" prop="live_title">
          <el-col :span="7">
            <!-- <el-input
              v-model="ruleForm.live"
              placeholder="请输入直播标题"
            ></el-input> -->
            <!-- <el-select
              v-model="ruleForm.live"
              filterable
              remote
              reserve-keyword
              placeholder="请输入直播关键词"
              :remote-method="searchLive"
              :loading="searchLoading"
            >
              <el-option
                v-for="item in live_options"
                :key="item.id"
                :label="item.live_title"
                :value="item.id"
              >
              </el-option>
            </el-select> -->
            <el-autocomplete
              :trigger-on-focus="false"
              style="width: 300px"
              value-key="live_title"
              :debounce="300"
              v-model="ruleForm.live_title"
              :fetch-suggestions="querySearchAsync"
              @select="handleSelect"
              placeholder="请输入直播关键词"
            ></el-autocomplete>
          </el-col>
        </el-form-item>
        <el-form-item>
          <div style="display: flex; justify-content: center">
            <el-button type="primary" @click="submitForm('ruleForm')"
              >立即创建</el-button
            >
            <!-- <el-button>取消</el-button> -->
          </div>
        </el-form-item>
      </el-form>
    </div>
    <Article ref="addarticle" :callback="reloadArticle"></Article>
  </div>
</template>
<script>
import "@/shared/plugins/element";
import Article from "../components/add-article.vue";
import Api from "@/api";
import moment from "moment";
import Table from "../publishComponents/table.vue";
import api from "@/api";
const baseURL = process.env.VUE_APP_BASEURL;
export default {
  name: "PostService",
  components: { Table, Article },
  data() {
    return {
      ruleForm: {
        live: "",
        live_title: "",
        dataList_text: "",
        fileList_poster: "", //海报地址集合
        dataList_article: "", //文章资讯集合
        fileList_img: "",
        fileList_video: "",
        fileList_videocover: "",
      },
      rules: {
        // live: [
        //   { required: true, message: "请选择关联直播", trigger: "blur" },
        //   // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        // ],
        // dataList_text: [
        //   { required: true, message: "请添加分享文案", trigger: "blur" },
        // ],
        // fileList_videocover: [
        //   { required: true, message: "请上传职位视频封面图", trigger: "blur" },
        // ],
        // fileList_video: [
        //   { required: true, message: "请上传职位相关视频", trigger: "blur" },
        // ],
      },
      fileList_video: [],
      fileList_img: [],
      fileList_poster: [],
      fileList_videocover: [],
      uploadUrl: baseURL + "/common/file/upload",
      job_attribute: "", // 2 全职 3 兼职
      headhunting: false,
      job_id: "",
      user_id: "",
      dataList_text: [],
      dataList_article: [],
      PageConfig: {
        pageArray: [10, 20, 50, 100],
        total: 0,
        searchList: {
          status: "1",
          uid: "",
          page: 1,
          pageSize: 10,
          taskid: "",
        },
      },
      tableHeaderText: [
        {
          show: true,
          type: "text", //渲染的表格行内数据类型
          prop: "content",
          width: "255", //表格列所占宽度
          label: "文案内容", //表格列名
          align: "center", //表格列数据对其方式
          fixed: false, //是否固定
          showOver: true,
        },
        {
          show: true,
          showFiled: "handle",
          type: "handle",
          width: "150",
          label: "操作",
          align: "center",
          fixed: "right",
        },
      ],
      tableHeaderArticle: [
        {
          show: true,
          type: "images", //渲染的表格行内数据类型
          prop: "front_cover_url",
          width: "255", //表格列所占宽度
          label: "封面图", //表格列名
          align: "center", //表格列数据对其方式
          fixed: false, //是否固定
          showOver: true,
        },
        {
          show: true,
          type: "text", //渲染的表格行内数据类型
          prop: "title",
          width: "255", //表格列所占宽度
          label: "标题", //表格列名
          align: "center", //表格列数据对其方式
          fixed: false, //是否固定
          showOver: true,
        },
        {
          show: true,
          type: "text", //渲染的表格行内数据类型
          prop: "description",
          width: "255", //表格列所占宽度
          label: "类型", //表格列名
          align: "center", //表格列数据对其方式
          fixed: false, //是否固定
          showOver: true,
        },
        {
          show: true,
          showFiled: "handle",
          type: "handle",
          width: "150",
          label: "操作",
          align: "center",
          fixed: "right",
        },
      ],
      share_text: "",
      dialogVisible: false,
      dialogImageUrl: [],
      live_options: "",
      searchLoading: false,
      video_cover_id: "",
    };
  },
  mounted() {
    this.job_id = this.$route.query.job_id;
    this.job_attribute = this.$route.query.job_attribute;
    this.headhunting = this.$route.query.headhunting;
    this.user_id = JSON.parse(localStorage.getItem("userJobInfo")).uid;
    this.getArticleList(); //获取文章列表
    this.getContentList(); //获取文案列表
    this.getResourceList("video"); //获取资源视频
    this.getResourceList("pic"); //获取资源图片
    this.getPosterList(); //获取海报
    this.getLiveJob(); //查询直播
  },
  methods: {
    handlePreview() {
      console.log("8888");
    },
    // 添加文案
    handleAddText() {
      this.share_text = "";
      this.$msgbox({
        title: "请输入分享文案",
        message: (
          <textarea
            vModel={this.share_text}
            style="width:97%;height:90px"
          ></textarea>
        ),
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(({ value }) => {
        let obj = {
          product_id: this.job_id,
          product_type: "3",
          content: this.share_text,
        };
        Api.post.addContentJob(obj).then((res) => {
          this.getContentList();
        });
      });
    },
    // 获取文案列表
    getContentList() {
      let params = {
        product_id: this.job_id,
        product_type: "3",
      };
      Api.post.getContentList(params).then((res) => {
        this.dataList_text = res;
        this.ruleForm.dataList_text = res;
      });
    },
    //修改文案
    handleEdit(row) {
      if (row) {
        this.share_text = row.content;
      }
      this.$msgbox({
        title: "请输入分享文案",
        message: (
          <textarea
            vModel={this.share_text}
            style="width:97%;height:90px"
          ></textarea>
        ),
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(({ value }) => {
        Api.post
          .editContentJob({
            id: row.id,
            content: this.share_text,
          })
          .then((res) => {
            this.getContentList();
          });
      });
    },
    //删除文案
    handleDelete(row) {
      Api.post
        .deleteContentJob({
          ids: row.id,
        })
        .then((res) => {
          this.getContentList();
        });
    },
    /**
     * 添加文章
     */
    handleAddArticle() {
      this.$refs.addarticle.open(this.job_id);
    },
    //修改文章
    articleEdit(row) {
      this.$refs.addarticle.edit(row);
    },
    //删除文章
    articleDelete(row) {
      Api.post
        .deleteArticleJob({
          ids: row.id,
        })
        .then((res) => {
          this.getArticleList();
        });
    },
    //获取文章列表
    getArticleList() {
      let params = {
        product_id: this.job_id,
        product_type: "3",
      };
      Api.post.getArticleList(params).then((res) => {
        this.dataList_article = res;
        this.ruleForm.dataList_article = res;
      });
    },

    // 重新渲染文章列表
    reloadArticle() {
      console.log("::::w");
      this.getArticleList();
    },

    /**
     * 海报
     */
    handleRemove(file, fileList) {
      this.deletePoster(file.id);
      console.log(this.ruleForm.poster_key_list);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
      console.log(file);
    },
    handlePoster(response, file, fileList) {
      this.postPoster(response.data);
      // this.ruleForm.poster_key_list = this.solveList(fileList);
      console.log(this.ruleForm.poster_key_list);
    },
    /** 处理key值list */
    solveList(fileList) {
      let arr = [];
      for (var i = 0; i < fileList.length; i++) {
        arr.push(fileList[i].response.data.key);
      }
      return arr;
    },
    solveName(fileList) {
      let arr = [];
      for (var i = 0; i < fileList.length; i++) {
        arr.push(fileList[i].response.data.name);
      }
      return arr;
    },
    /*
     * 资源上传
     */
    handleImages(response, file, fileList) {
      this.postImages(response.data);
    },
    imagesRemove(file, fileList) {
      this.deleteResource(file.id, "pic");
    },
    handleVideo(response, file, fileList) {
      this.postVideo(response.data);
    },
    //上传职位封面图
    handleVideoCover(response) {
      console.log(response.data);
      this.addVdieoCover(response.data);
    },
    videoCoverRemove() {
      Api.post
        .addVdieoCover({
          id: this.video_cover_id,
          front_cover_key: "",
        })
        .then((res) => {
          this.getResourceList("video");
        });
    },
    videoRemove(file, fileList) {
      this.deleteResource(file.id, "video");
    },
    // 关联直播
    async querySearchAsync(val, cb) {
      if (val) {
        let params = {
          keyword: val,
        };
        try {
          let data = await Api.post.searchLive(params);
          if (data.length > 0) {
            data.forEach((item, index) => {
              item.value = item.live_title;
            });
            console.log(data, 123);
            cb(data);
          } else {
            cb([{ value: "未查到直播信息" }]);
          }
        } catch (e) {
          //TODO handle the exception
        }
      }
    },
    handleSelect(item) {
      this.ruleForm.live_title = item.live_title;
      this.ruleForm.live = item.id;
    },
    submitForm(formName) {
      let that = this;
      if (this.fileList_video && this.fileList_video.length > 0) {
        this.rules.fileList_videocover = [
          { required: true, message: "请上传职位视频封面图", trigger: "blur" },
        ];
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          Promise.all([
            // this.postImages(),
            // this.postVideo(),
            // this.postPoster(),
            this.defaultPoster(),
            this.postLive(),
          ]).then((res) => {
            if (this.headhunting) {
              that.$message.info("保存成功！");
              that.$router.push({
                path: "/hunter-post",
              });
            } else {
              that.$info({
                title: "提交成功",
                content: "职位信息已提交成功，等待平台审核通过后即可上线",
                okText: "知道了",
                onOk() {
                  if (that.job_attribute === "2") {
                    that.$router.push({
                      path: "/post",
                    });
                  } else if (that.job_attribute === "4") {
                    that.$router.push({
                      path: "/money-task",
                    });
                  } else {
                    that.$router.push({
                      path: "/flexible-post",
                    });
                  }
                },
              });
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    // 获取资源列表
    getResourceList(resource_type) {
      Api.post
        .getResourceList({
          product_type: "3",
          product_id: this.job_id,
          resource_type: resource_type,
        })
        .then((res) => {
          let datalist = [];
          let front_cover_url = [];
          if (res.list && res.list.length > 0) {
            datalist = JSON.parse(
              JSON.stringify(res.list)
                .replace(/file_name/g, "name")
                .replace(/file_url/g, "url")
            );
            if (res.list[0].front_cover_url) {
              front_cover_url = JSON.parse(
                JSON.stringify(res.list)
                  .replace(/front_cover_key/g, "name")
                  .replace(/front_cover_url/g, "url")
              );
            }
          }
          if (resource_type == "video") {
            this.fileList_video = datalist;
            this.fileList_videocover = front_cover_url;
            this.ruleForm.fileList_videocover = front_cover_url
            this.video_cover_id = res.list.length > 0 && res.list[0].id;
            this.ruleForm.fileList_video = datalist;
          } else {
            this.fileList_img = datalist;
            this.ruleForm.fileList_img = datalist;
          }
        });
    },
    //删除资源接口
    deleteResource(id, resource_type) {
      Api.post
        .deleteResourceList({
          ids: id,
        })
        .then((res) => {
          this.getResourceList(resource_type);
        });
    },
    postVideo(res) {
      Api.post
        .addResourceJob({
          product_id: this.job_id,
          product_type: "3",
          user_id: this.user_id,
          user_type: "2",
          file_name: res.name,
          key: res.key,
          resource_type: "video",
        })
        .then((res) => {
          console.log(res.id);
          this.video_cover_id = res.id;
          this.getResourceList("video");
        });
    },
    postImages(res) {
      return Api.post
        .addResourceJob({
          product_id: this.job_id,
          product_type: "3",
          user_id: this.user_id,
          user_type: "2",
          file_name: res.name,
          key: res.key,
          resource_type: "pic",
        })
        .then((res) => {
          this.getResourceList("pic");
        });
    },
    //职位视频封面
    addVdieoCover(res) {
      return Api.post
        .addVdieoCover({
          id: this.video_cover_id,
          front_cover_key: res.key,
        })
        .then((res) => {
          this.getResourceList("video");
          // console.log(res)
        });
    },
    // 获取海报列表
    getPosterList(list) {
      Api.post
        .getPosterList({
          product_id: this.job_id,
          product_type: "3",
          poster_design_method: "20",
        })
        .then((res) => {
          let datalist = [];
          if (res && res.length > 0) {
            datalist = JSON.parse(
              JSON.stringify(res)
                .replace(/poster_bg_key/g, "name")
                .replace(/poster_bg_url/g, "url")
            );
          }
          if (!list) {
            this.fileList_poster = datalist;
          }
          this.ruleForm.fileList_poster = datalist;
        });
    },
    //删除海报
    deletePoster(id) {
      Api.post
        .deletePosterList({
          ids: id,
        })
        .then((res) => {
          let list = "true";
          this.getPosterList(list);
        });
    },
    postPoster(res) {
      // let arr = [];
      // arr.push(res.key);
      Api.post
        .addPosterJob({
          product_id: this.job_id,
          product_type: "3",
          poster_type: "20",
          poster_design_method: "20",
          poster_bg_key: res.key,
        })
        .then((res) => {
          let list = "true";
          this.getPosterList(list);
        });
    },
    defaultPoster(res) {
      Api.post
        .addPosterJob({
          product_id: this.job_id,
          product_type: "3",
          poster_design_method: "10",
        })
        .then((res) => {
          let list = "true";
          this.getPosterList(list);
        });
    },
    postLive() {
      return Api.post.addLiveJob({
        job_id: this.job_id,
        live_id: this.ruleForm.live_title ? this.ruleForm.live : "0",
      });
    },
    //查询直播
    getLiveJob() {
      Api.post
        .getLiveJob({
          job_id: this.job_id,
        })
        .then((res) => {
          if (res) {
            this.ruleForm.live = res.id;
            this.ruleForm.live_title = res.live_title;
            console.log(this.ruleForm.live_title, "88888888888888");
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.create {
  .header-timeline {
    margin: 50px auto;
    width: 45%;
  }
}
</style>